import React from 'react';
import { Camera } from 'lucide-react';
import { couplePhotos } from '../data/mock';
import { useLanguage } from '../LanguageContext';

export const Gallery = () => {
  const { t } = useLanguage();
  
  return (
    <section id="gallery" className="gallery-section">
      <div className="container">
        <div className="section-header">
          <Camera className="section-icon" />
          <h2 className="section-title">{t('gallery.title')}</h2>
          <div className="decorative-line-small"></div>
        </div>

        <div className="gallery-grid">
          {couplePhotos.map((photo, index) => (
            <div 
              key={index} 
              className="gallery-item"
              data-aos="zoom-in"
              data-aos-delay={index * 50}
            >
              <img src={photo} alt={`Moment ${index + 1}`} loading="lazy" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
